module.exports = __webpack_public_path__ + "img/amazon.uk.27a06dec.jpg";